import React, { useEffect } from "react";
import "./Notification.css";
import Common_Title_3 from "../common/common_components/Common_Title_3/Common_Title_3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications, updateNotificationStatus } from "../../features/notifications/notificationSlice";
import { IDS } from "../../utils/IDS";
import { encodeId, formatEventDate } from "../../utils/common";
const Notification = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notification);

  console.log({ llll: notifications });



  const GetNotifications = async () => {
    await dispatch(getNotifications())
  }

  useEffect(() => {
    GetNotifications()
  }, [])


  const onCheck = async (id) => {
    await dispatch(updateNotificationStatus(id));
    await GetNotifications();
  }




  return (
    <section className="Notification">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />
        <div className="top_div">
          <p className="event_text">Notifications</p>
          {/* <p className="event_text">Upcoming event</p> */}
        </div>

        <div className="event_card_holder">
          <div className="row">
            {notifications?.data?.data?.map((data, index) => {
              // 🔀 Decide redirect URL
              let redirectUrl = null;

              if (data?.Event) {
                redirectUrl = `/shibir-registration/${encodeId(data?.event_id)}`;
              } else if (data?.Product_Order) {
                redirectUrl = `/order-details/${encodeId(data?.order_id)}`;
              }

              const CardContent = (
                <div onClick={() => onCheck(data?.id)}>
                  <div className="card_section_title" >
                    <Common_Title_3
                      titleText={data?.message || ""}
                      hideSeeAll={true}
                    />
                  </div>

                  {data?.Event && (
                    <div className="below_content">
                      <div className="row">
                        <div className="col-xl-2 col-lg-3 col-sm-3 col-3 pe-0">
                          <div className="left_img_div">
                            <img
                              src={IDS.IMG_URL + data?.Event?.image}
                              className="inner_img"
                              alt="event"
                            />
                          </div>
                        </div>

                        <div className="col-xl-10 col-lg-9 col-sm-9 col-9">
                          <div className="right_side">
                            <p className="event_name">{data?.Event?.name}</p>
                            <p className="event_subtext">{data?.Event?.subname}</p>
                            <p className="date_text">
                              <FontAwesomeIcon
                                icon={faCalendarDays}
                                className="date_icon"
                              />{" "}
                              {formatEventDate(
                                data?.Event?.start_date,
                                data?.Event?.end_date
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );

              return (
                <div className="col-md-6" key={data?.id || index}>
                  <div className="event_card">

                    {redirectUrl ? (
                      <Link to={redirectUrl}>
                        {CardContent}
                      </Link>
                    ) : (
                      CardContent
                    )}

                  </div>
                </div>
              );
            })}


            {/* <div className="col-md-6">

              <div className="event_card">
                <Link to={'/event-details'}>
                  <div className="card_section_title">
                    <Common_Title_3
                      titleText="Guru Purnima Special"
                      hideSeeAll={true}
                    />
                  </div>
                  <div className="below_content">
                    <div className="row">
                      <div className="col-xl-2 col-lg-3 col-sm-3 col-3 pe-0">
                        <div className="left_img_div">
                          <img
                            src="/assets/images/notification/img1.png"
                            className="inner_img"
                          />
                        </div>
                      </div>
                      <div className="col-xl-10 col-lg-9 col-sm-9 col-9">
                        <div className="right_side">
                          <p className="event_name">Sadguru Arpanam</p>
                          <p className="event_subtext">
                            7 Days guru Purnima Preparation
                          </p>

                          <p className="date_text">
                            <FontAwesomeIcon
                              icon={faCalendarDays}
                              className="date_icon"
                            />{" "}
                            4 to 10 July
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div> */}
          </div>





        </div>
      </div>
    </section>
  );
};

export default Notification;
